
export default {
  data() {
    return {
      activeGalleryImage: this.activeImage,
      activeGalleryIndex: this.activeIndex,
    };
  },
  props: {
    activeIndex: {
      type: Number,
      required: true,
    },
    activeImage: {
      type: [Object, Array],
      required: true,
    },
    galleryItems: {
      type: [Object, Array],
      required: true,
    },
  },

  methods: {
    closeModal() {
      this.$emit("close-modal");
    },
    previousImg() {
      if (this.galleryItems && this.galleryItems.length) {
        if (this.activeGalleryIndex > 0) {
          this.activeGalleryIndex--;
        } else {
          this.activeGalleryIndex = this.galleryItems.length - 1;
        }

        this.activeGalleryImage =
          this.galleryItems[this.activeGalleryIndex].image;
      }
    },
    nextImg() {
      if (this.galleryItems && this.galleryItems.length) {
        if (this.activeGalleryIndex < this.galleryItems.length - 1) {
          this.activeGalleryIndex++;
        } else {
          this.activeGalleryIndex = 0;
        }

        this.activeGalleryImage =
          this.galleryItems[this.activeGalleryIndex].image;
      }
    },
  },
};
